import { useState } from "react";
import { Modal } from "antd";
import apiHelpers from "./data";
import { triggerNotification } from "../../common/notify";

const HardDeleteModal = ({ open, record, onCancel, onConfirmed }) => {
  const [deleting, setDeleting] = useState(false);

  if (!record) return null;

  const handleOk = async () => {
    setDeleting(true);
    try {
      await apiHelpers.hardDeleteVideo(record.id);
      triggerNotification({
        type: "success",
        title: "Deleted",
        message: `"${record.title || record.bamvideoId}" was permanently removed.`,
      });
      onConfirmed?.();
    } catch (err) {
      const mapped = apiHelpers.mapError(err);
      triggerNotification({
        type: "error",
        title: "Delete failed",
        message: mapped.message,
      });
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Delete video?"
      onCancel={onCancel}
      onOk={handleOk}
      okText="Yes"
      cancelText="No"
      okButtonProps={{ danger: true, loading: deleting }}
      maskClosable={false}
      destroyOnClose
      width={400}
    >
      Are you sure you want to permanently delete{" "}
      <b>{record.title || record.bamvideoId}</b>? This cannot be undone.
    </Modal>
  );
};

export default HardDeleteModal;
